import React from "react";

import './Banner.css'
import AboutText from "./About/AboutText";

function Abouts() {
    return (
        <div className="mt-14 mx-6 lg:mx-10 pb-16 " >
           
            <div >
                <h3 className="text- flex justify-center  text-3xl mb-6 text-highlight">
                <div className='flex gap-3 items-center  border-[2px] w-[219px] border-white py-1 px-5 hover:bg-white hover:text-black rounded-3xl'>Who Am I <span className="hover:rotate-180 "> <img className="w-6 h-6" alt="imag" loading="lazy" src="https://i.ibb.co/G3xK0m8/im.png"/></span></div>

                    {/* {"<"} Who Am I {"/>"} */}
                </h3>
                <AboutText/>
             
            </div>
            <div 
            data-aos="fade-up"
            data-aos-anchor-placement="center-bottom"
            className="flex md:flex-row  flex-col mt-14 justify-start items-center md:mt-20 text-center gap-20 lg:gap-52" >
                <div className="md:w-1/5  h-96 w-96 md:-mt- grid grid-cols-2 gap-6" data-aos="fade-left">
                    <img
                        src='https://i.ibb.co/JQG0z5X/about-programming.jpg'
                        // className="rounded-bl-full rounded-tr-full box md:w-2/3   "
                        alt=""
                        className="w-28 h-46 ml-6"
                    />
                    <img
                        src='https://i.ibb.co/WWKN4NS/about-reading-books.jpg'
                        // className="rounded-bl-full rounded-tr-full box md:w-2/3   "
                        alt=""
                        className="w-28 h-46 ml-6"
                    />
                    <img
                        src='https://i.ibb.co/wKrdZnG/430888.jpg'
                        // className="rounded-bl-full rounded-tr-full box md:w-2/3   "
                        alt=""
                        className="w-[260px] h-[160px] mx-6"
                        
                    />
                </div>
                <div className="md:w-1/2 md:text-start " data-aos="fade-right">
                    <h1 className="text-3xl w-full mx-auto text-white mb-8 "><span className="border-[2px] border-[#455ce9] !font-sans font-bold  hover:bg-white hover:text-black p-2 rounded-3xl md:leading-loose">About Me ✦</span></h1>

                    <div className=""> 
                        <p className="a-b text-start">
                            I was born and raised in a small town in Bangladesh called Barishal. 
                            When I enrolled in college in 2019 at the age of 16, I wasn’t sure what I wanted to do with my life. Initially, 
                            I thought my profession would be related to the civil engineer. And Before delving into the world of web development and design, 
                            I also worked as a waiter.
                        </p>
                        <div className="a-b-p text-start"> As a junior web developer I realized that I enjoyed the creative aspect of my work more,
                             and I made a full transition into the field of design. Since then, I have worked as a freelancer on platforms like upwork/Fiverr and collaborated with
                              companies and clients on a full-time or contract basis. I’ve worked with prominent companies and clients.
                        </div>
                  </div>

                    
                </div>
            </div>
        </div>
    );
}

export default Abouts;







